import type { Stop } from "../types";
import { API_ENDPOINTS } from "./apiEndpoints";

export interface Bounds {
  north: number;
  south: number;
  east: number;
  west: number;
}

function buildWfsPayload(bounds: Bounds | null): string {
  const typeName = "ogt:forsaljningsstallen";
  const props = ["namn", "typ", "url", "geom"];

  const propertyXml = props
    .map((p) => `<wfs:PropertyName>${p}</wfs:PropertyName>`)
    .join("");

  const filters: string[] = [
    `
      <ogc:PropertyIsEqualTo>
        <ogc:PropertyName>typ</ogc:PropertyName>
        <ogc:Literal>automat</ogc:Literal>
      </ogc:PropertyIsEqualTo>
      `,
  ];

  if (bounds) {
    const coords = `${bounds.south},${bounds.west} ${bounds.north},${bounds.east}`;
    filters.push(`
        <ogc:BBOX>
        <ogc:PropertyName>geom</ogc:PropertyName>
        <Box srsName="urn:ogc:def:crs:EPSG::4326">
            <coordinates>${coords}</coordinates>
        </Box>
        </ogc:BBOX>
      `);
  }

  const filterXml = `<ogc:Filter><ogc:And>${filters.join(
    ""
  )}</ogc:And></ogc:Filter>`;

  return `
      <GetFeature service="WFS" version="1.0.0" outputFormat="application/json"
        xmlns:wfs="http://www.opengis.net/wfs"
        xmlns:ogc="http://www.opengis.net/ogc"
        xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
        xsi:schemaLocation="http://www.opengis.net/wfs http://schemas.opengis.net/wfs/1.0.0/WFS-basic.xsd">
        <Query typeName="${typeName}">
          ${propertyXml}
          ${filterXml}
        </Query>
      </GetFeature>
    `.trim();
}

export async function fetchTicketMachines(
  bounds: Bounds | null = null
): Promise<Stop[]> {
  const payload = buildWfsPayload(bounds);

  const res = await fetch(API_ENDPOINTS.GEO_FETCH, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `=${encodeURIComponent(payload)}`,
  });

  if (!res.ok) {
    console.error("geo/fetch ticketAgents error:", res.status);
    return [];
  }

  const geojson = await res.json();

  return (geojson.features as any[]).map((feat) => {
    const props = feat.properties;
    const [lng, lat] = feat.geometry.coordinates;

    return {
      id: feat.id,
      name: props.namn.trim(),
      lat,
      lng,
      type: "ticketMachine",
    } as Stop;
  });
}
